import PropTypes from 'prop-types';
import React from "react";

import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { SkeletonTheme } from 'react-loading-skeleton';


// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";

import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import PrivateRoute from './routes/PrivateRoute';
import './App.css'

const App = props => {

  const Layout = VerticalLayout;


  return (
    <React.Fragment>
      <SkeletonTheme baseColor="#2A3042" highlightColor="#2a3c55aa">
      <BrowserRouter>
        <Routes>
        
          {publicRoutes.map(({path, component: Component}, idx) => {
            return (
              <Route
                path={path}
                element={
                  <NonAuthLayout>
                    <Component />
                  </NonAuthLayout> 
                }
              />
          )})}

          <Route path="/" element={<PrivateRoute />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            {authProtectedRoutes.map(({path, component: Component}, idx) => {
              return (
                <Route path={path} element={<Layout><Component /></Layout>}/>
            )})}
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      </SkeletonTheme>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
};

export default connect(mapStateToProps, null)(App);
